// @mui material components
import { useState, useEffect, useReducer, useMemo, useContext, useCallback } from "react";
import Card from "@mui/material/Card";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Kaizen Dashboard examples
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import { urlBase } from "../../services/config";
import { CircularProgress, Grid, InputLabel, MenuItem, Pagination, Select } from "@mui/material";

// Data

import axios from "axios";
import { Link } from "react-router-dom";
import dataRemito from "layouts/remito/components/dataRemito";
import DataTable from "components/DataTable";
import { MessageManager } from "context";
import { ConfirmarContext } from "context/ConfirmarContext";
import ModalCambiarDestino from "./ModalCambioDestino";
const baseURL = urlBase + "remitoEncabezadosPaginate";

const initialState = {
  searchInput: "",
  pagina: 1,
  estado: "Todos",
  fecha: "",
  destino: "Todas",
  nroRemito: "",
  codProv: "",
};

const filtroReducer = (state, action) => {
  switch (action.type) {
    case "SET_SEARCH_INPUT":
      return {
        ...state,
        searchInput: action.payload,
        pagina: 1,
      };
    case "SET_PAGINA":
      return {
        ...state,
        pagina: action.payload,
      };
    case "SET_ESTADO":
      return {
        ...state,
        estado: action.payload,
        pagina: 1,
      };
    case "SET_SUCURSAL_DESTINO":
      return {
        ...state,
        destino: action.payload,
        pagina: 1,
      };
    case "SET_CODIGO_PROV":
      return {
        ...state,
        codProv: action.payload,
        pagina: 1,
      };
    default:
      return state;
  }
};

const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;
const esUsuarioDeposito =
  String(parsedUser?.nombre || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase() === "deposito";

const getInitialState = () => ({
  ...initialState,
  estado: esUsuarioDeposito ? "Enviado" : "Todos",
});

function debounce(func, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
}

function Tables() {
  const { handleSnackbar } = useContext(MessageManager);
  const { confirmar } = useContext(ConfirmarContext);

  const [loading, setLoading] = useState(false);
  const [cantidadPaginas, setCantidadPaginas] = useState(1);
  const [filtroState, dispatch] = useReducer(filtroReducer, undefined, getInitialState);
  const [listadoRemitos, setListadoRemitos] = useState([]);
  const [modalCambiarDestino, setModalCambiarDestino] = useState(false);
  const [remito, setRemito] = useState(null);
  const [listadoSucursales, setListadoSucursales] = useState([]);
  const { columns, getRows } = dataRemito;

  const handleSearch = useCallback(
    debounce((value) => {
      dispatch({ type: "SET_SEARCH_INPUT", payload: value });
    }, 500),
    []
  );
  const handleSearchProducto = useCallback(
    debounce((value) => {
      dispatch({ type: "SET_CODIGO_PROV", payload: value });
    }, 500),
    []
  );

  const handlePagination = (e, value) => {
    dispatch({ type: "SET_PAGINA", payload: value });
  };
  const getRemitos = async () => {
    setLoading(true);
    try {
      const estadoSeleccionado = String(filtroState.estado || "")
        .trim()
        .toLowerCase();

      const response = await axios.get(`${baseURL}?page=${filtroState.pagina}`, {
        params: {
          // search: filtroState.searchInput,
          sucursal: parsedUser.codigo,
          estado: filtroState.estado,
          ...(estadoSeleccionado === "enviado" ? { ordenFecha: "asc" } : {}),
          destino: filtroState.destino,
          numero: filtroState.searchInput || null,
          codProv: filtroState.codProv || null,
        },
      });
      setListadoRemitos(response.data.data);
      setCantidadPaginas(response.data.meta?.last_page);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const borrarRemito = async (id) => {
    setLoading(true);
    const dateD = new Date().toLocaleString("af-ZA", {
      hour12: false,
    });
    try {
      await axios.delete(`${urlBase}remitoEncabezados/${id}`);
      handleSnackbar("Borrado correctamente", "success");
      getRemitos();
    } catch (error) {
      console.log(error);
      handleSnackbar(
        "Ha ocurrido un error al borrar, el remito puede haber sido recepcionado.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const getSucursales = async () => {
      try {
        const response = await axios.get(urlBase + "users");
        setListadoSucursales(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    getSucursales();
  }, []);

  useEffect(() => {
    getRemitos();
  }, [filtroState]);

  const ejecutarAccionUsuario = (accion, item) => {
    switch (accion) {
      case "borrar":
        confirmar({
          title: "Advertencia",
          message: "¿Está seguro que desea borrar? Esta acción no se puede deshacer.",
          icon: "warning",
          func: () => {
            borrarRemito(item.id);
          },
        });
        break;
      case "cambiar":
        setRemito(item);
        setModalCambiarDestino(true);
        break;
      default:
        break;
    }
  };

  const allRows = useMemo(
    () => getRows(listadoRemitos, ejecutarAccionUsuario, parsedUser?.nombre),
    [listadoRemitos]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <SoftTypography variant="h6">Sucursal: {parsedUser?.nombre}</SoftTypography>
          {esUsuarioDeposito && (
            <SoftBox display="flex" alignItems="center" gap={1}>
              <SoftBox
                sx={{
                  width: 14,
                  height: 14,
                  minWidth: 14,
                  borderRadius: "50%",
                  backgroundColor: "rgba(225, 64, 64, 0.57)",
                  border: "1px solid rgba(211, 47, 47, 0.75)",
                }}
              />
              <SoftTypography variant="caption" color="text">
                Remitos sin recibir por más de 24 hs
              </SoftTypography>
            </SoftBox>
          )}
        </SoftBox>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" px={3}>
              <SoftTypography variant="h6">Remitos</SoftTypography>
              <SoftBox display="flex" justifyContent="" alignItems="center" py={3}>
                <SoftBox mr={2}>
                  {/* <SoftInput
                    placeholder="Buscar..."
                    icon={{ component: "search", direction: "left" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                  /> */}
                </SoftBox>
                <SoftBox>
                  <Link to="/remito">
                    <SoftButton variant="gradient" color="dark" size="large">
                      Nuevo
                    </SoftButton>
                  </Link>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <Grid display="flex" justifyContent="flex-end" alignItems="flex-end" mb={1}>
              <SoftBox mr={2}>
                <InputLabel htmlFor="estado">
                  <SoftTypography variant="subtitle2" fontWeight="bold" color="dark">
                    Buscar por producto
                  </SoftTypography>
                </InputLabel>
                <SoftBox display="flex" flexDirection="row" alignItems="center">
                  <SoftInput
                    placeholder="Buscar por cod prov"
                    icon={{ component: "search", direction: "left" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearchProducto(e);
                      }
                    }}
                    onChange={(e) => {
                      handleSearchProducto(e.target.value);
                    }}
                  />
                </SoftBox>
              </SoftBox>
              <SoftBox mr={2}>
                <InputLabel htmlFor="estado">
                  <SoftTypography variant="subtitle2" fontWeight="bold" color="dark">
                    Sucursal destino
                  </SoftTypography>
                </InputLabel>
                <Select
                  value={filtroState.destino}
                  onChange={(e) =>
                    dispatch({ type: "SET_SUCURSAL_DESTINO", payload: e.target.value })
                  }
                >
                  <MenuItem value={"Todas"}>Todas</MenuItem>
                  {listadoSucursales
                    .filter((sucursal) => sucursal.name !== "admin")
                    .map((sucursal) => (
                      <MenuItem key={sucursal.id} value={sucursal.codigo}>
                        {sucursal.name}
                      </MenuItem>
                    ))}
                </Select>
              </SoftBox>
              <SoftBox mr={2}>
                <InputLabel htmlFor="estado">
                  <SoftTypography variant="subtitle2" fontWeight="bold" color="dark">
                    Buscar por N°
                  </SoftTypography>
                </InputLabel>
                <SoftBox display="flex" flexDirection="row" alignItems="center">
                  <SoftTypography variant="subtitle2" fontWeight="bold" color="dark">
                    {parsedUser?.codigo.toString().length === 1
                      ? "000" + parsedUser.codigo + "-"
                      : "00" + parsedUser.codigo + "-"}
                  </SoftTypography>
                  <SoftInput
                    placeholder="Buscar..."
                    icon={{ component: "search", direction: "left" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(e);
                      }
                    }}
                    onChange={(e) => {
                      handleSearch(e.target.value);
                    }}
                  />
                </SoftBox>
              </SoftBox>
              <SoftBox mr={2}>
                <InputLabel htmlFor="estado">
                  <SoftTypography variant="subtitle2" fontWeight="bold" color="dark">
                    Estado
                  </SoftTypography>
                </InputLabel>
                <Select
                  value={filtroState.estado}
                  onChange={(e) => dispatch({ type: "SET_ESTADO", payload: e.target.value })}
                >
                  <MenuItem value={"Todos"}>Todos</MenuItem>
                  <MenuItem value={"Envio parcial"}>Envio parcial</MenuItem>
                  <MenuItem value={"Enviado"}>Enviado (para recibir)</MenuItem>
                  <MenuItem value={"Recibido"}>Recibido</MenuItem>
                  <MenuItem value={"Recibo parcial"}>Recibo parcial</MenuItem>
                </Select>
              </SoftBox>
            </Grid>
            <SoftBox>
              {loading ? (
                <SoftBox display="flex" justifyContent="center" py={12}>
                  <CircularProgress color="primary" />
                </SoftBox>
              ) : listadoRemitos.length > 0 ? (
                <DataTable columns={columns} rows={allRows} />
              ) : (
                <Grid display="flex" justifyContent="center" py={12}>
                  <SoftTypography variant="body1" color="dark">
                    No hay datos
                  </SoftTypography>
                </Grid>
              )}
            </SoftBox>
          </Card>
          <Card sx={{ mt: 2 }}>
            <Grid
              container
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              py={2}
            >
              <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                <Pagination
                  count={cantidadPaginas}
                  defaultPage={1}
                  siblingCount={1}
                  color="primary"
                  page={filtroState.pagina}
                  onChange={handlePagination}
                />
              </Grid>
            </Grid>
          </Card>
        </SoftBox>
        <ModalCambiarDestino
          open={modalCambiarDestino}
          handleClose={() => {
            setModalCambiarDestino(false);
          }}
          remito={remito}
          refetch={getRemitos}
        />
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
